import template from './app.html';
import './app.styl';
import controller from './app.controller';

let appComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js